import React from 'react';

import CriticReview from 'vivino-js/components/CriticReview';

import styles from './criticReviewList.scss';

const MAX_REVIEWS = 3;

interface Props {
  criticReviewList: any[];
}

const CriticReviewList = ({ criticReviewList }: Props) =>
  (criticReviewList || []).length > 0 && (
    <div className={styles.criticReviewList}>
      {criticReviewList.slice(0, MAX_REVIEWS).map((criticReview) => (
        <div key={criticReview.wine_critic_review_id} className={styles.quotedRating}>
          <div className={styles.quote}>{criticReview.pull_quote}</div>
          {criticReview?.wine_critic?.name && (
            <div className={styles.namedCritic}>
              <CriticReview criticReview={criticReview} large={!criticReview.pull_quote} />
              <div className={styles.criticName}>{criticReview.wine_critic.name}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );

export default CriticReviewList;
